/**
 * Public waiting room for World Cup squad invites.
 * URL: /wc-invite/<inviteCode>
 *
 * Resolves the squad (no auth) → shows a branded preview card → routes to
 * sign-up/sign-in with `returnUrl` pointing at the auto-join screen so the
 * user lands directly in the squad after authenticating.
 */

import { useMemo } from 'react';
import { useLocalSearchParams, Redirect } from 'expo-router';
import { ErrorBoundary } from '../../components/layout';
import { WorldCupInviteWaitingRoom } from '../../components/onboarding/WorldCupInviteWaitingRoom/WorldCupInviteWaitingRoom';

const INVITE_CODE_RE = /^[A-Za-z0-9-]{4,32}$/;

export default function WorldCupInviteRoute() {
  const { code } = useLocalSearchParams<{ code?: string | string[] }>();
  const inviteCode = useMemo(() => {
    const raw = Array.isArray(code) ? code[0] : code;
    if (typeof raw !== 'string') return null;
    const trimmed = raw.trim();
    if (!INVITE_CODE_RE.test(trimmed)) return null;
    return trimmed;
  }, [code]);

  if (!inviteCode) {
    return <Redirect href="/" />;
  }

  return (
    <ErrorBoundary>
      <WorldCupInviteWaitingRoom inviteCode={inviteCode} />
    </ErrorBoundary>
  );
}
